<div class="row">
  <div class="col-md-6">

    <div class="form-group row">
      <label for="dateOfBirth" class="col-sm-4 col-form-label">Date Of Birth</label>
      <div class="col-sm-8">
        <input type="date" class="form-control form-control-sm" id="dateOfBirth" placeholder="Date Of Birth" [(ngModel)]="formData.dateOfBirth">
      </div>
    </div>

    <div class="form-group row">
      <label for="employmentStatus" class="col-sm-4 col-form-label">Employment Status</label>
      <div class="col-sm-8">
        <select id="employmentStatus" class="form-control form-control-sm" [(ngModel)]="formData.employmentStatus">
          <option>Select..</option>
          <option value="Full-Time">Full-Time</option>
          <option value="Part-Time">Part-Time</option>
          <option value="Self-Employed">Self-Employed</option>
          <option value="Unemployed">Unemployed</option>
          <option value="Retired">Retired</option>
          <option value="Student">Student</option>
        </select>
      </div>
    </div>

    <div class="form-group row">
      <label for="residentialStatus" class="col-sm-4 col-form-label">Residential Status</label>
      <div class="col-sm-8">
        <select id="residentialStatus" class="form-control form-control-sm" [(ngModel)]="formData.residentialStatus">
          <option>Select..</option>
          <option value="e53b45f025fb8df52e5b61c6">Homeowner</option>
          <option value="5dec148aa7d3b792fbcd0741">Renting</option>
          <option value="c1c327ec1946b5d5ad46747f">Living With Parents</option>
        </select>
      </div>
    </div>

  </div>
  <div class="col-md-6">

    <div class="form-group row">
      <label for="nationalInsuranceNumber" class="col-sm-4 col-form-label">NI Number</label>
      <div class="col-sm-8">
        <input type="text" class="form-control form-control-sm" id="nationalInsuranceNumber" placeholder="National Insurance Number"
          [(ngModel)]="formData.nationalInsuranceNumber">
      </div>
    </div>

    <div class="form-group row">
      <label for="maritalStatus" class="col-sm-4 col-form-label">Marital Status</label>
      <div class="col-sm-8">
        <select id="maritalStatus" class="form-control form-control-sm" [(ngModel)]="formData.maritalStatus">
          <option>Select..</option>
          <option>Married</option>
          <option>Single</option>
          <option>Divorced</option>
          <option>Separated</option>
        </select>
      </div>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/personal-information/app-personal-information.component.html